import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/popular-courses`;

export const popularCoursesRoutesObj = {
  list: baseRoute,
} as const;

export type IPopularCoursesRouteParams = IExtractRouteParamMap<
  typeof popularCoursesRoutesObj
>;

export const popularCoursesPath = createPaths<
  typeof popularCoursesRoutesObj,
  IPopularCoursesRouteParams
>(popularCoursesRoutesObj);
